import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2487a9f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "editRoom",
  tabindex: "-1",
  "aria-labelledby": "editRoom",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroup"
}
const _hoisted_6 = { class: "row mx-5 px-0 pb-4 my-4 justify-content-lg-center" }
const _hoisted_7 = { class: "col-lg-3 col-form-label fw-bold pad-left" }
const _hoisted_8 = { class: "col-lg-2 col-form-label" }
const _hoisted_9 = { class: "col-lg-7" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_12 = { class: "row mx-5 px-0 pb-4 my-4 justify-content-lg-center" }
const _hoisted_13 = { class: "col-lg-5 fw-bold" }
const _hoisted_14 = { class: "col-lg-7 mx-0 d-flex fs-7" }
const _hoisted_15 = { class: "mx-2" }
const _hoisted_16 = { class: "me-2" }
const _hoisted_17 = { class: "row mx-5 px-0 justify-content-lg-center" }
const _hoisted_18 = { class: "col-lg-5 fw-bold" }
const _hoisted_19 = { class: "col-lg-7 mb-5" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_22 = { class: "row mx-5 px-0" }
const _hoisted_23 = { class: "col-lg-3 fw-bold" }
const _hoisted_24 = { class: "col-lg-2" }
const _hoisted_25 = { class: "col-lg-7 mb-5" }
const _hoisted_26 = { class: "d-flex" }
const _hoisted_27 = { class: "form-check col-lg-3" }
const _hoisted_28 = ["for"]
const _hoisted_29 = ["id"]
const _hoisted_30 = { class: "form-check col-lg-6" }
const _hoisted_31 = ["for"]
const _hoisted_32 = ["id"]
const _hoisted_33 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_34 = {
  class: "modal fade",
  id: "confirmModalEditRoom",
  tabindex: "-1",
  "aria-labelledby": "confirmModalEditRoom",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-lg" }
const _hoisted_36 = { class: "modal-content" }
const _hoisted_37 = { class: "modal-header" }
const _hoisted_38 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_40 = { class: "modal-body" }
const _hoisted_41 = { class: "row mb-4 px-3" }
const _hoisted_42 = { class: "col-lg-4 fw-bold" }
const _hoisted_43 = { class: "col-lg-8" }
const _hoisted_44 = { class: "row mb-4 px-3" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold" }
const _hoisted_46 = { class: "col-lg-8 gx-0 mx-0 d-flex fs-7" }
const _hoisted_47 = { class: "me-2 mx-2" }
const _hoisted_48 = { class: "me-2" }
const _hoisted_49 = { class: "row mb-4 px-3" }
const _hoisted_50 = { class: "col-lg-4 fw-bold" }
const _hoisted_51 = { class: "col-lg-8 text-break break-spaces" }
const _hoisted_52 = { class: "row px-3" }
const _hoisted_53 = { class: "col-lg-4 fw-bold" }
const _hoisted_54 = { class: "col-lg-8" }
const _hoisted_55 = { class: "text-break break-spaces" }
const _hoisted_56 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_57 = {
  class: "modal fade",
  id: "editRoomSuccess",
  tabindex: "-1",
  "aria-labelledby": "editRoomSuccess",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header" }
const _hoisted_61 = {
  class: "modal-title text-center fw-bold w-100",
  id: "editRoomSuccess"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_63 = { class: "" }
const _hoisted_64 = { class: "text-center my-4" }
const _hoisted_65 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength } from '@vuelidate/validators'

import UserAliasIcon from '@/components/user-alias-icon'
//constant
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { computed, onMounted, ref, watchEffect } from 'vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { GROUPS_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import { customMaxLength } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  talkRoomId: String,
  count: Number,
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const loadingEdit = ref<boolean>(false)
const editFailed = ref<boolean>(false)
const detailTalkRoom = computed(() => store.getters[GROUPS_STORE.GETTERS.DETAIL_TALK_ROOM])


const rules = computed(() => {
  return {
    name: {
      required,
      maxLength: (value: string) => customMaxLength(value, 30),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    information: {
      maxString: (value: string) => customMaxLength(value, 200),
    },
    published: {},
  }
})

const formData = ref({
  name: '',
  information: '',
  published: '',
})
watchEffect(() => {
  if (props.talkRoomId && props.count)
    formData.value = {
      name: detailTalkRoom.value?.name,
      information: detailTalkRoom.value?.information,
      published: detailTalkRoom.value?.published,
    }
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loading.value = true

  isCheckedNGKeyName.value = false
  isCheckedNGKeyInfo.value = false
  await checkNGKeyName()
  await checkNGKeyInfo()
  while (!isCheckedNGKeyName.value || !isCheckedNGKeyInfo.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (v$.value.$invalid || ngKeyName.value || ngKeyInfo.value) {
    loading.value = false
    return
  }

  modalEdit.value.hide()
  modalConfirm.value.show()
  loading.value = false
}

// 2022/09/12 TienNV Fix double click button confirm edit
const modalEdit = ref()
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalEdit.value = new Modal(document.getElementById('editRoom'))
  modalConfirm.value = new Modal(document.getElementById('confirmModalEditRoom'))
  modalSuccess.value = new Modal(document.getElementById('editRoomSuccess'))
})

const EditRoom = async () => {
  loadingEdit.value = true
  try {
    const response = await groupsService.editTalkRoomApi(props.talkRoomId, { talkroom: formData.value, create_by_admin: true })
    if (response?.status === 200) {
      editFailed.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS, {
        id: route.params?.group_id,
        params: {
          ...route.query,
          page: route.query?.page || 1,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
    } else {
      editFailed.value = true
    }
    // 2022/09/12 TienNV Fix double click button confirm edit
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingEdit.value = false
    }, 2000)
  } catch (error) {
    editFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loadingEdit.value = false
    console.log(error)
  }
}

const resetData = async () => {
  formData.value = {
    name: detailTalkRoom.value?.name,
    information: detailTalkRoom.value?.information,
    published: detailTalkRoom.value?.published,
  }
  ngKeyName.value = false
  ngKeyInfo.value = false
}

const isCheckedNGKeyName = { value: false }
const ngKeyName = ref<boolean>(false)
const checkNGKeyName = debounce(async () => {
  const queryData = { sentence: v$.value.name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyName.value = true
  }
}, 200)

const isCheckedNGKeyInfo = { value: false }
const ngKeyInfo = ref<boolean>(false)
const checkNGKeyInfo = debounce(async () => {
  const queryData = { sentence: v$.value.information.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyInfo.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyInfo.value = true
  }
}, 200)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('talkRoomName')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "name",
                  class: _normalizeClass(['form-control', ngKeyName.value || _unref(v$).name.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyName) && _unref(checkNGKeyName)(...args))),
                  placeholder: _unref(translate)('placeholder')
                }, null, 42, _hoisted_10), [
                  [
                    _vModelText,
                    _unref(v$).name.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyName.value && !_unref(v$).name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('talkRoomName'),
                  validator: _unref(v$).name.$errors[0]?.$validator,
                  params: [1, 30]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(UserAliasIcon), {
                  userType: _unref(detailTalkRoom)?.admin?.user_type
                }, null, 8, ["userType"]),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(detailTalkRoom)?.admin?.management_no), 1),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(detailTalkRoom)?.admin?.family_name + ' ' + _unref(detailTalkRoom)?.admin?.given_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('OC40talkRoomDes')), 1),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "information",
                  class: _normalizeClass(['form-control', ngKeyInfo.value || _unref(v$).information.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).information.$model) = $event)),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyInfo) && _unref(checkNGKeyInfo)(...args))),
                  placeholder: _unref(translate)('placeholder')
                }, null, 42, _hoisted_20), [
                  [
                    _vModelText,
                    _unref(v$).information.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyInfo.value && !_unref(v$).information.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('OC40talkRoomDes'),
                  validator: _unref(v$).information.$errors[0]?.$validator,
                  params: [200]
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: _ctx.public
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "flexRadioDefault",
                        id: _ctx.public,
                        value: true,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).published.$model) = $event))
                      }, null, 8, _hoisted_29), [
                        [_vModelRadio, _unref(v$).published.$model]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                    ], 8, _hoisted_28)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: _ctx.private
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "flexRadioDefault",
                        id: _ctx.private,
                        value: false,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).published.$model) = $event))
                      }, null, 8, _hoisted_32), [
                        [_vModelRadio, _unref(v$).published.$model]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                    ], 8, _hoisted_31)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                class: "button-confirm-modal",
                "data-bs-dismiss": "modal",
                className: 'fw-bold',
                onClick: resetData
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                disabled: loading.value,
                loading: loading.value,
                className: 'fw-bold'
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _hoisted_39
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(translate)('talkRoomName')), 1),
                _createElementVNode("div", _hoisted_43, _toDisplayString(formData.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('creator')), 1),
                _createElementVNode("div", _hoisted_46, [
                  _createVNode(_unref(UserAliasIcon), {
                    userType: _unref(detailTalkRoom)?.admin?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(detailTalkRoom)?.admin?.management_no), 1),
                  _createElementVNode("p", _hoisted_48, _toDisplayString(_unref(detailTalkRoom)?.admin?.family_name + ' ' + _unref(detailTalkRoom)?.admin?.given_name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(translate)('explanatoryText')), 1),
                _createElementVNode("div", _hoisted_51, _toDisplayString(formData.value.information), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("p", _hoisted_55, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#editRoom',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('SO40UpdateConfirm'),
                type: 'secondary',
                className: 'fw-bold',
                loading: loadingEdit.value,
                disabled: loadingEdit.value,
                onClick: EditRoom
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("h5", _hoisted_61, _toDisplayString(_unref(translate)('OC42editTitle')), 1),
            _hoisted_62
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("p", _hoisted_64, _toDisplayString(editFailed.value ? _unref(translate)('SO10editTalkRoomError') : _unref(translate)('OC42editTitleMess')), 1)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})